<style scoped lang="less">
@import '../assets/css/less.less';
.app-register{position: fixed; left: 0; top: 0; z-index: 1; width: 100%; height: 100%;
   background: rgba(0, 0, 0, 0.6); .box;
   z-index: 999;
}
.app-con{position: relative; z-index: 0; .box; width: 574/@r; height: 622/@r;
  
}
.app-img{ position: absolute; left: 0; top: 0; z-index: -1; width: 100%; height: 100%;}
.app-text{position: absolute; left: 50%; transform: translateX(-50%); bottom: 46/@r; width: 70%; .box; .box-h;}
.app-con input{ width: 100%; height: 80/@r; border: 2/@r solid #cccccc; border-radius: 10/@r;
  font-size: 26/@r; background: #fff; margin-bottom: 34/@r;
  box-sizing: border-box; padding: 0 20/@r;
}
.app-btn{ width: 196/@r; height: 86/@r; .box;}
.app-btn img{width: 100%; height: 100%;}
.app-text-p{ color: #999; font-size: 24/@r; text-align: left; display: block; padding-bottom: 30/@r; width: 100%;}
</style>
<template>
    <div class="app-register" v-if="isshow">
         <div class="app-con">
             <img class="app-img" src="../assets/img/answer5.png">
             <div class="app-text">
                <input type="text" v-model="name" placeholder="请输入姓名">
                <input type="number" v-model="phone" placeholder="请输入手机号">
                <!-- <p class="app-text-p">温馨提示 : 仅限东莞手机号码</p> -->
                <div class="app-btn" @touchstart="startFu" @touchmove="moveFu" @touchend="btnFu">
                    <img src="../assets/img/answer6.png">
                </div>
             </div>
         </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
           name:'',
           phone:'',
           start:0,
           isajax:false,//是否正在提交
           isshow:false,
        }
    },
    beforeMount(){
        // let register = this.getStorageSync('register');
        if(!this.$store.state.status.mobile){
            this.isshow = true;
        }
    },
    methods:{
        tispFn(info){
            wx.showToast({
            title: info,
            icon: 'none',
            duration: 1500
        })
        },
        startFu(){this.start=0;},
        moveFu(){this.start = 1;},
        btnFu(){
            if(this.start == 1 || this.isajax){return;}
            if(this.name == ""){
                this.tispFn('真实姓名不能为空')
                // this.$parent.$refs.caiToast.showFu({
                //     msg:'真实姓名不能为空',
                //     time:1500
                // })
                return;
            }
            if(!/^[\u4e00-\u9fa5]{2,5}$/.test(this.name)){
                
                this.tispFn('真实姓名填写错误')
                return;
            }
            if(this.phone == ""){
                this.tispFn('手机号码不能为空')
        
                return;
            }
            if(!/^1[3|4|5|7|8][0-9]{9}$/.test(this.phone)){
    
                this.tispFn('手机号码填写错误')
                return;
            }
           this.isajax = true;
           this.$http.post(`${this.service}questionnaire/user-edit?access-token=${this.$store.state.access_token}`,{
               mobile:this.phone,
               name:this.name
           }).then((data)=>{
               this.isajax = false;
               if(data.status == 1){
                //    this.setStorageSync('register',1);
                   this.isshow = false;
               }
                this.tispFn(data.info)
               
           })
        }
    }
}
</script>  


// WEBPACK FOOTER //
// src/components/register.vue